'use strict';

var Switch = require('./Switch');
var ButtonSwitch = require('./ButtonSwitch');
Switch.ButtonSwitch = ButtonSwitch;

module.exports = Switch;


/*****************
 ** WEBPACK FOOTER
 ** ./~/hdk-switch/lib/index.js
 ** module id = 87
 ** module chunks = 0
 **/